<div class="data-summary-container" *ngIf="summary">
  <mat-expansion-panel class="help-expansion-panel" [expanded]="expanded" #panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="panel-icon" svgIcon="summary-blue"></mat-icon>
        {{ title }}
      </mat-panel-title>
      <!-- <mat-panel-description *ngIf="!panel.expanded">
        <div class="assessment-preview" *ngIf="summary.overall_assessment">
          <span class="preview-text">{{ summary.overall_assessment }}</span>
        </div>
      </mat-panel-description> -->
    </mat-expansion-panel-header>

    <!-- Overall Assessment - Shown when expanded -->
    <div class="assessment-full" *ngIf="summary.overall_assessment">
      <p class="assessment-text">{{ summary.overall_assessment }}</p>
    </div>

    <!-- Bullet Points -->
    <div class="bullet-points-section" *ngIf="summary.bullet_points && summary.bullet_points.length > 0">
      <h4 class="section-title">Key Insights</h4>
      <ul class="bullet-points-list">
        <li *ngFor="let point of summary.bullet_points" class="bullet-point">
          {{ point }}
        </li>
      </ul>
    </div>

    <!-- Key Statistics -->
    <!-- <div class="statistics-section" *ngIf="summary.key_statistics && summary.key_statistics.length > 0">
      <h4 class="section-title">Statistics</h4>
      <div class="statistics-grid">
        <div 
          *ngFor="let stat of summary.key_statistics" 
          class="stat-card"
          [ngClass]="getCategoryColor(stat.scope)">
          <div class="stat-header">
            <mat-icon class="stat-icon">{{ getCategoryIcon(stat.scope) }}</mat-icon>
            <span class="stat-category">{{ stat.scope || 'General' }}</span>
          </div>
          <div class="stat-content">
            <div class="stat-description">{{ stat.description }}</div>
            <div class="stat-value">{{ stat.value }}</div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Generated At -->
    <div class="generated-at" *ngIf="summary.generated_at">
      <span class="generated-label">Generated:</span>
      <span class="generated-value">{{ summary.generated_at | date:'yyyy-MM-dd HH:mm' }}</span>
    </div>
  </mat-expansion-panel>
</div>
